import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import AmendEVDCDeviceProvider from "./baseProviders/amendEVDCDeviceProvider"
import useStartNewEvdcDeviceAmendment from "../../../../../services/middleware/hooks/devices/lct/useStartNewEvdcDeviceAmendment"

interface INewEVDCDeviceAmendmentFormUrlParams {
    deviceRef: string
}

interface INewEVDCDeviceAmendmentProviderProps {
    children: ReactNode
}

const NewEVDCDeviceAmendmentProvider = ({
    children,
}: INewEVDCDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewEVDCDeviceAmendmentFormUrlParams
    >() as INewEVDCDeviceAmendmentFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: newEvdcDeviceAmendmentError,
    } = useStartNewEvdcDeviceAmendment(urlDeviceRef, attachmentUUID)

    return (
        <AmendEVDCDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newEvdcDeviceAmendmentError}
            attachmentUUID={attachmentUUID}
            systemReference={urlDeviceRef}
        >
            {children}
        </AmendEVDCDeviceProvider>
    )
}

export default NewEVDCDeviceAmendmentProvider
